import {
  TypedUseSelectorHook,
  useDispatch as useOriginDispatch,
  useSelector as useOriginSelector,
} from 'react-redux';

import type { AppDispatch, RootState } from '../store';

export const useDispatch = () => useOriginDispatch<AppDispatch>();

export const useSelector: TypedUseSelectorHook<RootState> = useOriginSelector;
